import React from 'react';
import { Card } from "../ui/card.tsx"
import { ArrowUpRight } from "lucide-react"
import { Button } from "../ui/button.tsx"

export function ColleaguesCard() {
  return (
    <Card className="p-6">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-semibold">Colleagues</h3>
        <Button variant="ghost" size="icon">
          <ArrowUpRight className="h-4 w-4" />
        </Button>
      </div>
    </Card>
  )
}

